import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';
import { CustomerItem, TypeaheadService } from '../../../services/typeahead.service';

@Component({
  selector: 'tt-cust-grp',
  templateUrl: './cust-grp.component.html',
  styleUrls: ['./cust-grp.component.css']
})
export class CustGrpComponent implements OnInit {
    public custGrpId: string;

    public edit?: Edit;

    public selectListDiscGroupCustomers: DiscGroupCustomerItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService, private typeahead: TypeaheadService) {
        this.custGrpId = this.stateService.getStateParams()['custgrp_id'];
    }

    private async loadEdit() {
        if (!!this.custGrpId) {
            this.edit = (await this.datatask.Post(1009, { custgrp_id: this.custGrpId }))[0];
        }
    }

    private async loadDiscGroupCustomers() {
        this.selectListDiscGroupCustomers = await this.datatask.Post(3124);
    }

    public searchDefaultCustNames = () => {
        return this.typeahead.searchCustomer({
            cust_name: this.edit!.default_cust_name,
            custtype: 'C',
            lastselect: 'SEARCH'
        });
    }

    public onDefaultCustNameSelected(event?: CustomerItem) {
        if (!this.edit) return;

        this.edit.default_cust_no = !!event ? '' + event.item_id : '0';
        this.edit.default_cust_name = event?.item_name ?? '';
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                var response = await this.datatask.Post(1010, this.edit);

                // BJS 20260907 - Returner bare dersom der ikke er en validerings melding fra databasen.
                if (!response.validation) {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadDiscGroupCustomers();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    custgrp_id: string;
    custgrp_name: string;
    show_numbers_incl_tax: string;
    default_cust_no: string;
    default_cust_name: string;
    discgrpcust_keyno: string;
    pricerise_on_broken_package: string;
}

interface DiscGroupCustomerItem {
    discgrpcust_keyno: string;
    discgrpcust_name: string;
    orderby: number;
}
